import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { createTeam } from '../../api/authenticateAPIs';
import { useNotification } from '../../context/NotificationContext';
import { NotificationType } from '../../enums/NotificationType';
import { useNavigate } from 'react-router-dom';

import UsersMultiselect from '../../components/shared/UsersMultiselect';
import EnvironmentsMultiselect from '../../components/shared/EnvironmentsMultiSelect';
import AccessMultiselect from '../../components/shared/AccessMultiselect';
import '../../css/pages/manage_teams.css';

const CreateTeam = () => {

    const { showNotification } = useNotification();
    const navigate = useNavigate();
    const [t] = useTranslation('global');
    const [isLoading, setIsLoading] = useState(false);
    const [showAdGroupNumber, setShowAdGroupNumber] = useState(false);
    const [formData, setFormData] = useState({name: '', userIds: [], envIds: [], adDn: '', accessIds: []});

    useEffect(() => {
        setShowAdGroupNumber(!!formData.adDn);
    }, [formData.adDn]);

    const validateFormData = () => {
        let isValid = true;

        if (!formData.name) {
            showNotification({ message: t('teamNameRequired'), type: NotificationType.Error });
            isValid = false;
        } else if (!formData.userIds.length) {
            showNotification({ message: t('usersRequired'), type: NotificationType.Error });
            isValid = false;
        } 
        // else if (!formData.envIds.length) {
        //     showNotification({ message: t('environmentsRequired'), type: NotificationType.Error });
        //     isValid = false;
        // }

        return isValid;
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    } 

    const handleAdGroupToggle = () => {
        setShowAdGroupNumber(prev => !prev);
    };

    const handleUserChange = (event) => {
        const {
            target: { value },
        } = event;
        setFormData({
            ...formData,
            userIds: typeof value === 'string' ? value.split(',') : value,
        });
    }; 

    const handleEnvironmentChange = (event) => {
        const {
            target: { value },
        } = event;
        setFormData({
            ...formData,
            envIds: typeof value === 'string' ? value.split(',') : value,
        });
    };

    const handleAccessChange = (event) => {
        const { target: { value } } = event;
        setFormData({
            ...formData,
            accessIds: typeof value === 'string' ? value.split(',') : value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        if (validateFormData()) {

            console.log('Submitting: ', formData.name, formData.userIds, formData.envIds);
            try {
                const adDnToSave = showAdGroupNumber ? formData.adDn : '';
                await createTeam(formData.name, formData.userIds, formData.envIds, adDnToSave, formData.accessIds)
                .then(result => {
                    showNotification({ message: t('teamCreated'), type: NotificationType.Success });
                })
                .catch(ex =>{
                    showNotification({ message: ex.message, type: NotificationType.Error });
                })
            } catch (error) {
                console.error("Error creating team: ", error);
            } finally {
                setIsLoading(false);
                handleGoBack();
            }
        } else {
            setIsLoading(false); 
        }
    };

    const handleGoBack = () => {
        navigate('/Teams');
    };

    return (
    <div className='page-wrap'>
        <button className="return-button return-button-top" onClick={handleGoBack}>
            <span className="material-symbols-outlined">arrow_back</span>{t('return')}
        </button>
        <div className="header-title">
            <h1>{t('newTeam')}</h1>
          </div>

        <form onSubmit={handleSubmit} autoComplete="off" className="input-form">
            <div className='input-section'>
                <div className='input-line'>
                    <label htmlFor='name'>{t('teamName')}</label>
                    <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                    />
                </div>
            </div>

            <div className='input-section'>
                <div className='input-line'>
                    <UsersMultiselect
                        selectedValues={formData.userIds}
                        onChange={handleUserChange}
                        disabled={showAdGroupNumber}
                    />
                    {showAdGroupNumber && (
                        <span className='team-ad-group-note'>{t('adMembersManaged')}</span>
                    )}
                </div>
            </div>
           
            <div className='input-section'>
                <div className='input-line'>
                    <EnvironmentsMultiselect
                        selectedValues={formData.envIds}
                        onChange={handleEnvironmentChange}
                    /> 
                </div>
            </div>

            <div className='input-section'>
                <div className='input-line'>
                    <AccessMultiselect
                        selectedValues={formData.accessIds}
                        onChange={handleAccessChange}
                    />
                </div>
            </div>

            <div className='input-section'>
                <div className='input-line'>
                    <div className='ad-group-toggle-row'>
                        <label className='switch' htmlFor='adGroupToggle'>
                            <input
                                type='checkbox'
                                id='adGroupToggle'
                                checked={showAdGroupNumber}
                                onChange={handleAdGroupToggle}
                            />
                            <span className='slider'></span>
                        </label>
                        <span className='team-ad-group-note'>{t('adGroupHint')}</span>
                    </div>
                </div>
            </div>

            {showAdGroupNumber ? (
                <div className='input-section'>
                    <div className='input-line'>
                        <label htmlFor='adDn'>{t('adGroupNumber')}</label>
                        <input
                            type="text"
                            id="adDn"
                            name="adDn"
                            placeholder={t('adGroupPlaceholder')}
                            value={formData.adDn}
                            onChange={handleChange}
                        />
                    </div>
                </div>
            ) : null}
        </form>

        <button className="submit-button" type="submit" disabled={isLoading} onClick={handleSubmit}>{t('submit')}</button>
    </div>
    );
}
export default CreateTeam;